import SecurityFormContainer from './security-form-container';

export default SecurityFormContainer;
